var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaDxfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.972,
    height: 90.05,
    viewBox: "0 0 78.972 90.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minerva_dxf_icon",
    transform: "translate(-1345 -8755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minerva_dxf_icon-2",
    "data-name": "minerva_dxf_icon",
    transform: "translate(1345 8755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186278",
    "data-name": "\\uADF8\\uB8F9 186278",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186276",
    "data-name": "\\uADF8\\uB8F9 186276",
    transform: "translate(7.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186262",
    "data-name": "\\uADF8\\uB8F9 186262",
    transform: "translate(4.233 4.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186261",
    "data-name": "\\uADF8\\uB8F9 186261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139169",
    "data-name": "\\uD328\\uC2A4 139169",
    d: "M128.808,122.743H65.7a1.821,1.821,0,0,1-1.821-1.821V38.747A1.821,1.821,0,0,1,65.7,36.926h63.107a1.821,1.821,0,0,1,1.821,1.821v82.174A1.821,1.821,0,0,1,128.808,122.743Z",
    transform: "translate(-63.879 -36.926)",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186275",
    "data-name": "\\uADF8\\uB8F9 186275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186273",
    "data-name": "\\uADF8\\uB8F9 186273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186263",
    "data-name": "\\uADF8\\uB8F9 186263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139170",
    "data-name": "\\uD328\\uC2A4 139170",
    d: "M97.97,27.631H56.4a1.821,1.821,0,0,0-1.821,1.821v82.174a1.821,1.821,0,0,0,1.821,1.821h63.107a1.821,1.821,0,0,0,1.821-1.821V50.239Z",
    transform: "translate(-54.583 -27.631)",
    fill: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186265",
    "data-name": "\\uADF8\\uB8F9 186265",
    transform: "translate(1.82 1.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186264",
    "data-name": "\\uADF8\\uB8F9 186264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139171",
    "data-name": "\\uD328\\uC2A4 139171",
    d: "M59.491,107.458a.913.913,0,0,1-.911-.911V32.541a.914.914,0,0,1,.269-.642.9.9,0,0,1,.642-.269H85.664a.911.911,0,1,1,0,1.821H60.4v73.1A.91.91,0,0,1,59.491,107.458ZM89.306,33.451a.911.911,0,1,1,.911-.911A.91.91,0,0,1,89.306,33.451Z",
    transform: "translate(-58.58 -31.63)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186266",
    "data-name": "\\uADF8\\uB8F9 186266",
    transform: "translate(0 18.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139172",
    "data-name": "\\uD328\\uC2A4 139172",
    d: "M116.78,67.605v61.24a1.821,1.821,0,0,1-1.821,1.821H54.583V133.4A1.821,1.821,0,0,0,56.4,135.22h63.107a1.821,1.821,0,0,0,1.821-1.821V72.011Z",
    transform: "translate(-54.583 -67.605)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186267",
    "data-name": "\\uADF8\\uB8F9 186267",
    transform: "translate(0 20.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139173",
    "data-name": "\\uD328\\uC2A4 139173",
    d: "M119.057,72.444v61.314a1.821,1.821,0,0,1-1.821,1.821H54.583v.455a1.821,1.821,0,0,0,1.821,1.821h63.107a1.821,1.821,0,0,0,1.821-1.821V74.647Z",
    transform: "translate(-54.583 -72.444)",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186272",
    "data-name": "\\uADF8\\uB8F9 186272",
    transform: "translate(8.404 31.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186268",
    "data-name": "\\uADF8\\uB8F9 186268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139174",
    "data-name": "\\uD328\\uC2A4 139174",
    d: "M120.866,100.535H75.155a2.116,2.116,0,0,1-2.116-2.116h0A2.116,2.116,0,0,1,75.155,96.3h45.711a2.116,2.116,0,0,1,2.116,2.116h0A2.117,2.117,0,0,1,120.866,100.535Z",
    transform: "translate(-73.039 -96.302)",
    fill: "#e8566f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186269",
    "data-name": "\\uADF8\\uB8F9 186269",
    transform: "translate(0 12.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139175",
    "data-name": "\\uD328\\uC2A4 139175",
    d: "M120.866,128.731H75.155a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h45.711a2.116,2.116,0,0,1,2.116,2.116h0A2.117,2.117,0,0,1,120.866,128.731Z",
    transform: "translate(-73.039 -124.498)",
    fill: "#b7032d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186270",
    "data-name": "\\uADF8\\uB8F9 186270",
    transform: "translate(0 25.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139176",
    "data-name": "\\uD328\\uC2A4 139176",
    d: "M120.866,156.926H75.155a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h45.711a2.116,2.116,0,0,1,2.116,2.116h0A2.117,2.117,0,0,1,120.866,156.926Z",
    transform: "translate(-73.039 -152.693)",
    fill: "#e8566f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186271",
    "data-name": "\\uADF8\\uB8F9 186271",
    transform: "translate(0 38.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139177",
    "data-name": "\\uD328\\uC2A4 139177",
    d: "M120.866,185.122H75.155a2.116,2.116,0,0,1-2.116-2.116h0a2.116,2.116,0,0,1,2.116-2.116h45.711a2.116,2.116,0,0,1,2.116,2.116h0A2.117,2.117,0,0,1,120.866,185.122Z",
    transform: "translate(-73.039 -180.889)",
    fill: "#b7032d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186274",
    "data-name": "\\uADF8\\uB8F9 186274",
    transform: "translate(43.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139178",
    "data-name": "\\uD328\\uC2A4 139178",
    d: "M149.867,48.532a1.707,1.707,0,0,0,1.707,1.707H173.23L149.867,27.631Z",
    transform: "translate(-149.867 -27.631)",
    fill: "#d1d3d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_186277",
    "data-name": "\\uADF8\\uB8F9 186277",
    transform: "translate(0 6.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139179",
    "data-name": "\\uD328\\uC2A4 139179",
    d: "M80.05,57.833H38.859a1.821,1.821,0,0,1-1.821-1.821V43.4a1.821,1.821,0,0,1,1.821-1.821H80.05A1.821,1.821,0,0,1,81.871,43.4V56.012A1.821,1.821,0,0,1,80.05,57.833Z",
    transform: "translate(-37.038 -41.574)",
    fill: "#e63950"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139402",
    "data-name": "\\uD328\\uC2A4 139402",
    d: "M8.954,20.576V10.189H12.2a8.453,8.453,0,0,1,3.439.565,4.36,4.36,0,0,1,1.947,1.737,5.488,5.488,0,0,1,.713,2.9,5.383,5.383,0,0,1-.741,2.809,4.4,4.4,0,0,1-1.982,1.809,8.208,8.208,0,0,1-3.35.565Zm2.274-8.753v7.12h1.117q3.577,0,3.577-3.57,0-3.55-3.577-3.55Zm17.82,8.753h-2.7l-2.405-3.7-2.454,3.7H19.014l3.667-5.218-3.591-5.169h2.695l2.343,3.563,2.4-3.563h2.488L25.4,15.269Zm8.763-8.664h-5v2.309h4.535v1.716H32.822v4.639H30.548V10.189h7.265Z",
    transform: "translate(1344.221 8753.8)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaDxfIcon);
export default __webpack_public_path__ + "static/media/minerva_dxf_icon.5eb3d5aeabbe9c1f6a2724b9751b6ecb.svg";
export { ForwardRef as ReactComponent };